export default __webpack_public_path__ + "media/images/images/portfolio/portfolio-1-1ab53ed96f0f6abb48dacadbc41aa177.jpg";